import { AssociateMemberForNonprofitStatus, USER_ROLES } from './constants';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';

export const isSellerAssociate = (summary: any): boolean =>
    summary?.roleId === USER_ROLES.PRACTICE_SECONDARY_USER &&
    (summary?.engagements ?? []).some(
        (e: any) => e.party === TimelineParty.Seller
    );

const getApprovedNonprofitMapping = (summary: any): any =>
    (summary?.associateMember ?? [])
        .map((am: any) => am?.nonprofitMapping)
        .find(
            (m: any) =>
                m?.associateMemberStatus ===
                AssociateMemberForNonprofitStatus.APPROVED
        );

export const isCharityAffiliatedMember = (summary: any): boolean =>
    !!getApprovedNonprofitMapping(summary);

export const isBuyerUser = (user: any): boolean =>
    (user?.roleId === USER_ROLES.USER ||
        user?.roleId === USER_ROLES.PRACTICE_SECONDARY_USER) &&
    !!user?.isMarketplaceBuyer;

export const getCharityAffiliationId = (summary: any): number | undefined =>
    getApprovedNonprofitMapping(summary)?.nonprofitId;
